<template>
  <div>
    <div v-if="loadedDefaultPayment && defaultPayment.has_default">
      <el-card class="text-center">
        已存支付方式: #### #### #### {{ defaultPayment.card_last_four }} ({{
          defaultPayment.card_brand.toUpperCase()
        }})
      </el-card>
    </div>
    <div v-loading="loading"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loadedDefaultPayment: false,
      defaultPayment: {
        has_default: false,
        card_brand: "visa",
        card_last_four: "0000"
      },
      loading: true
    };
  },
  computed: {
    ...mapState(["user"])
  },
  components: {},
  methods: {
    fetchDefaultPayment: function() {
      this.loading = true;
      this.$http
        .get("/user/payment")
        .then(res => {
          if (res.status === 200) {
            this.defaultPayment = res.data;
            this.$emit("defaultPayment", this.defaultPayment);
          }
          this.loading = false;
        })
        .catch(ex => {
          console.log(ex.message);
          this.loading = false;
        });
      this.loadedDefaultPayment = true;
    }
  },
  mounted: function() {
    this.fetchDefaultPayment();
  }
};
</script>
<style></style>
